// extracted by mini-css-extract-plugin
export default {"title":"Title_title__CWlc2","apperanceAnim":"Title_apperanceAnim__TAV5P"};